import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0554fb8"
import script from "./historyRecord.js?vue&type=script&lang=js&external"
export * from "./historyRecord.js?vue&type=script&lang=js&external"
import style0 from "./historyRecord.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports